import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * Debounce click directive
 * @class DebounceClickDirective
 * @typedef {DebounceClickDirective}
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Directive( {
    selector: '[debounceClick]',
    standalone: true
} )
export class DebounceClickDirective implements OnInit, OnDestroy {
    /** debouce duration */
    @Input() debounceTime = 500;
    /** click event emitter to notify parent component */
    @Output() doClick = new EventEmitter();

    /** subscription handler */
    private clicks = new Subject();
    private subscription: Subscription = new Subscription();

    /** set subscription and wait for debounce duration before clicks will be emitted */
    ngOnInit() {
        this.subscription = this.clicks
            .pipe( debounceTime( this.debounceTime ) )
            .subscribe( ( e ) => this.doClick.emit( e ) );
    }

    /** unsubscribe from event handler subscription */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    /** click event handler */
    @HostListener( 'click', ['$event'] )
    clickEvent( event: MouseEvent ) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next( event );
    }
}
